import { SectionHeading } from './ui';

const ADVANTAGES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Kiểm soát rủi ro chính xác',
    desc: 'Xác định đúng số tiền rủi ro cho từng lệnh, không còn đoán mò khối lượng.',
  },
  {
    icon: 'ri-umbrella-line',
    title: 'Bảo vệ vốn dài hạn',
    desc: 'Giữ mỗi lệnh thua trong giới hạn nhỏ, giúp tài khoản sống sót qua chuỗi thua lỗ.',
  },
  {
    icon: 'ri-emotion-line',
    title: 'Loại bỏ cảm xúc',
    desc: 'Quyết định khối lượng dựa trên con số, không phải lòng tham hay nỗi sợ hãi.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Nhanh chóng & nhất quán',
    desc: 'Tính trong vài giây, áp dụng cùng một quy tắc cho mọi giao dịch.',
  },
];

const WHEN_TO_USE = [
  {
    icon: 'ri-add-circle-line',
    title: 'Mở mọi lệnh giao dịch',
    desc: 'Luôn tính khối lượng trước khi vào lệnh, không bao giờ đặt bừa.',
  },
  {
    icon: 'ri-wallet-3-line',
    title: 'Khi số dư thay đổi',
    desc: 'Nạp thêm hay rút vốn đều cần tính lại khối lượng cho phù hợp.',
  },
  {
    icon: 'ri-rocket-2-line',
    title: 'Khi thử chiến lược mới',
    desc: 'Chiến lược mới có mức rủi ro khác, cần điều chỉnh khối lượng tương ứng.',
  },
  {
    icon: 'ri-global-line',
    title: 'Khi giao dịch nhiều sản phẩm',
    desc: 'Pip value và quy tắc khác nhau giữa các cặp tiền, kim loại và chứng khoán.',
  },
];

export default function ExampleSection() {
  return (
    <section>
      <SectionHeading
        eyebrow="Vì sao"
        title="Vì sao bạn cần Máy tính Khối lượng?"
        subtitle="Khối lượng lệnh là nền tảng của quản trị rủi ro. Đây là lý do mọi trader nên tính toán trước mỗi giao dịch."
      />

      {/* Why intro banner */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-violet-600 to-violet-800 p-7 text-white lg:col-span-2 md:p-9">
          <div className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 rounded-full bg-white/10" />
          <div className="pointer-events-none absolute -bottom-14 -right-4 h-40 w-40 rounded-full bg-white/5" />
          <div className="relative">
            <p className="font-display text-xl font-bold leading-snug md:text-2xl">
              Hầu hết trader thất bại không phải vì phân tích sai, mà vì đặt khối lượng quá lớn so với mức rủi ro có thể chịu đựng.
            </p>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-violet-100 md:text-base">
              Chỉ một vài lệnh thua nặng cũng đủ xóa sạch nhiều lệnh thắng trước đó. Máy tính khối lượng giúp bạn khóa chặt rủi ro từng lệnh, để không một giao dịch nào có thể phá hủy tài khoản của bạn.
            </p>
          </div>
        </div>

        {/* Key stat */}
        <div className="flex flex-col justify-center rounded-2xl border border-amber-200/80 bg-amber-50/60 p-7 md:p-9">
          <span className="text-sm font-semibold text-amber-700">Quy tắc vàng</span>
          <p className="mt-2 font-display text-4xl font-bold tracking-tight text-amber-600 md:text-5xl">
            &le; 2%
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            Rủi ro tối đa mỗi lệnh không nên vượt quá 2% vốn, giúp bạn sống sót ngay cả khi thua liên tiếp.
          </p>
        </div>
      </div>

      {/* Advantages */}
      <p className="mt-10 text-sm font-semibold uppercase tracking-wide text-slate-500">
        Lợi ích nổi bật
      </p>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ADVANTAGES.map((item) => (
          <div
            key={item.title}
            className="group rounded-2xl border border-slate-200/80 bg-white p-6 transition-colors hover:border-violet-200"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-violet-50 text-violet-600 transition-colors group-hover:bg-violet-600 group-hover:text-white">
              <i className={`${item.icon} text-xl`} />
            </div>
            <p className="mt-4 text-sm font-bold text-slate-900">{item.title}</p>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* When to use */}
      <div className="mt-10 rounded-2xl border border-slate-200/80 bg-white p-6 md:p-8">
        <p className="text-sm font-semibold text-slate-800">Khi nào cần sử dụng?</p>
        <div className="mt-5 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {WHEN_TO_USE.map((item) => (
            <div key={item.title} className="flex gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
                <i className={`${item.icon} text-lg`} />
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-800">{item.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-slate-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}